module.exports = __webpack_public_path__ + "9babb5b1a97360f55ebd9d7cac36ca65.svg";